import { useEffect } from "react"

const useInterval = (callback, interval) => {
  useEffect(() => {
    const interval = setInterval(callback, interval)
    return () => clearInterval(interval)
  }, [callback, interval])
}
export default useInterval